export const showToastStateAction = (state = false, action) => {
  switch (action.type) {
    case "SHOW_TOAST":
      return action.data;

    default:
      return state;
  }
};
